import { create } from "zustand";

interface State {
  /** The task block currently "armed" (dwelled over for ~1s during a drag) — it
   *  animates to signal that releasing here will nest the dragged task under it. */
  armedId: string | null;
  arm: (id: string) => void;
  disarm: () => void;
}

export const useNestHoverStore = create<State>((set) => ({
  armedId: null,
  arm: (id) => set({ armedId: id }),
  disarm: () => set((s) => (s.armedId ? { armedId: null } : s)),
}));
